<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'quality-iqcInspectionReport',
  components: {
    PageTable,
  },
}
</script>
